import React from "react"
import {
  animationSlideUp,
  animationSlideRight,
  animationZoomIn,
} from "../../utils/scroll-animation"
import Hints from "../../common/hints/hints"

export default function Stack(props) {
  const { stack, styles } = props
  return (
    <section
      style={{
        backgroundColor: stack?.backgroundColor
          ? stack.backgroundColor.hex
          : "",
      }}
      className={styles.stack}
    >
      <div className="default-container">
        <div className={styles.stackContainer}>
          <div className={styles.titleWrapper}>
            <h1 {...animationSlideRight()}>{stack.title}</h1>
            <Hints
              hints={stack?.hints}
              isAnimation={stack?.isHintsAnimation}
              typingBackground={
                stack?.backgroundColor ? stack.backgroundColor.hex : "#271b4f"
              }
            />
          </div>
          <div className={styles.contentWrapper}>
            <div className={styles.content}>
              <div className={styles.history} {...animationZoomIn()}>
                <img src={stack.images[0].asset.url} />
              </div>
              <div className={styles.desc} {...animationSlideUp()}>
                <div className={styles.stackItemContainer}>
                  {stack.tech_stacks?.map((tech, index) => (
                    <div className={styles.stackItem} key={index}>
                      <h1>{tech.title}</h1>
                      <p>{tech.description}</p>
                      <div className={styles.stackItemTech}>
                        {tech.techs.map((item, index) => (
                          <img key={index} src={item.logo.asset.url} />
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
                <div className={styles.stackGradient} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
